import { makeBreakpoints } from '@utils/css';

const userAreaBreakpoints = makeBreakpoints({
  mobile: 0,
  desktop: 901
});

export { userAreaBreakpoints };
//# sourceMappingURL=const.breakpoints.js.map
